/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { defineMessages } from 'react-intl';

import { ErrorType, I18NErrorType } from '../types/CommonTypes';

const messages = defineMessages({
  error: 'Error',
});

export const formatErrorResponse = (error: ErrorType): string => {
  // First check from the direct properties
  let message = error.message || error.ex || error.internalEx;
  // Then check the nested response properties
  if (error.response && error.response.ex) {
    message = error.response.ex;
  } else if (error.response && error.response.internalEx) {
    message = error.response.internalEx;
  } else if (error.response && error.response.message) {
    message = error.response.message; // eslint-disable-line prefer-destructuring
  }
  return message;
};

/**
 * function that format the I18NError object thrown from API
 * @param {function} formatMessage function from useIntl
 * @param {I18NErrorType} error I18N Error object thrown from API
 * @param {string} defaultErrorMessage default error message when we dont find any error message in response
 * @returns {string} formatted error text
 */
export const formatI18NErrorResponse = (
  formatMessage,
  error?: I18NErrorType,
  defaultErrorMessage = formatMessage(messages.error)
): string => {
  const message = (error?.response?.message ?? error?.values?.response?.ex) || defaultErrorMessage;
  return error?.i18nMessage ? formatMessage(error.i18nMessage, { message }) : message;
};
